import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('tole');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="temoignage" className="bg-slate-primary py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          {/* Image */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20Quebec%20two-story%20house%20with%20new%20dark%20slate%20blue%20standing%20seam%20metal%20roof%2C%20manicured%20front%20yard%2C%20warm%20golden%20afternoon%20sunlight%2C%20Saint-Nicolas%20suburban%20neighborhood%2C%20premium%20residential%20architecture%2C%20editorial%20magazine%20photography%2C%20no%20text%20visible%2C%20copper%20gutter%20accents%2C%20landscape%20composition&width=800&height=600&seq=tole-temoin1&orientation=landscape"
                alt="Maison avec toiture joint debout ardoise neuve à Saint-Nicolas près de Lévis par couvreur RBQ"
                className="w-full h-64 md:h-96 object-cover object-top"
                loading="lazy"
                width="800"
                height="600"
              />
            </div>
          </div>

          {/* Texte */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="flex items-center gap-1 mb-5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-copper text-lg" />
              ))}
            </div>

            <blockquote className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
              "{t('temoin_text')}"
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-copper flex items-center justify-center text-white font-bold text-xs">
                TB
              </div>
              <div>
                <p className="font-manrope font-bold text-white text-sm">{t('temoin_name')}</p>
                <p className="text-white/50 text-xs">
                  {t('temoin_location')} — {t('temoin_project')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-white/40 text-xs mt-10 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}